
angular.module('mtic.components.navbar')
.directive('navBarAdminView', function (EventManager, $timeout, $log, userAccount, api) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
    },
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarAdminView', scope)

      scope.broadCastAdminShow = function(){
        eventManager.broadcast('show_admin_view');
      }


    }
  }
})
